import { updateAllQuillObjects } from './../content/content-utilities';
/**
 *
 *
 *   WARNING WARNING WARNING
 *   TODO
 *    need to check if this is really the structure we want and
 *    where this is used?
 *
 */

import { extent } from 'd3-array';
import orderBy from 'lodash/orderBy';
// import { orderBy } from 'lodash-es';

import { ChartTypes, EChartTypes, GroupedOrStackedTypes, LineChartTypes, MapTypes, TableTypes } from '../config/constants';
import {
  getIsoFieldName,
  getLabelFieldName,
  getOldFields,
  getRightLabelFieldName,
  getRightLegendFieldName,
  getTimeFieldName,
  getValueFieldName,
} from '../config/dimension.config';
import { createNewValueFieldFromExisting, setNewValueField } from '../content/content-utilities';
import { validateNonCircularData } from '../content/echarts/sankey';
import { findBestUniquenessFieldNames } from '../content/uniquenes';
import { type Content, type DataRow, EChartType, Field } from '../models';
import { cloneObject, unique } from '../utilities';
import { momentToStr, objToMoment } from '../utilities/date';
import { getNumberFormat, getOptimalDecimalPlaces, parseMultiFilterData, parseMultiFilterValue, stringToNumber } from './utilities';

/*
  Transform ( Clean, Format, Sort, Restructure)
  Data according to Content Type Specific
 */

/**
 * Applies filters that are visible in the embeded visual
 * like  a timeline slider component
 */
const applyInVisualFilter = (content, data: DataRow[], recalc = true) => {
  const { inVisualFilter } = content.typeSpecific;
  //  console.log("[DataPipeline Applying InvisualFilter] - ",inVisualFilter)
  //  inVisualFilter.sort(sortByExecuteFirst);
  for (const filter of inVisualFilter) {
    switch (filter.type) {
      case 'valueSelector': {
        //  console.log('CALLING SMART FUNCTIONS', content.typeSpecific, inVisualFilter);
        const ret = applyValueSelectorInVisualFilter(content, data, filter, recalc);
        data = ret.data;
        content = ret.content;
        break;
      }
      case 'multiValueSelector': {
        const ret = applymultiValueSelectorInVisualFilter(content, data, filter, recalc);
        data = ret.data;
        content = ret.content;
        break;
      }
      default:
        console.error('smartFunction Error no implementation for: ', filter, data, content);
    }
    //  console.log("[DataPipeline After InvisualFilter] - ",filter)
  }

  return { content: content, data: data };
};

const applymultiValueSelectorInVisualFilter = (content, data: DataRow[], filter, recalc) => {
  const { fieldName, options } = filter;
  //const { sort } = options;
  const sortConfig = {
    enabled: content.typeSpecific?.style?.inVisualFilter?.dropdown?.items?.ordering?.enabled,
    desc: content.typeSpecific?.style?.inVisualFilter?.dropdown?.items?.ordering?.desc,
  };

  if (!filter.localStorage) filter.localStorage = {};

  //  if localStorage defined and has a value -> use this
  const { format } = content.typeSpecific.fields[fieldName];
  //  console.log("Updating sorted Values",format, filter);
  if (format.formatType === 'string' || format.formatType === 'number') {
    let values: any[] = [];

    if (options.multiFilterValues && format.formatType === 'string') {
      values = parseMultiFilterData(data, fieldName, options.multiFilterDelimiter ?? '|');
    } else {
      values = data.map((obj) => obj[fieldName]);
    }

    const uniqueValues = unique(values);
    if (sortConfig.enabled) {
      const sortedValues = orderBy(uniqueValues, [], sortConfig.desc ? 'desc' : 'asc');
      filter.localStorage.filterValues = sortedValues;
    }
    filter.localStorage.filterValues = uniqueValues;

    //const sortedValues = orderBy(uniqueValues, [], sort);
    //filter.localStorage.filterValues = sortedValues;
  }

  if (format.formatType === 'date') {
    const uniqueValues = unique(data.map((obj) => obj[fieldName]));
    const dateValues = uniqueValues.map((obj) => {
      const date = objToMoment(obj, format.date.inputFormat, format.locale);
      return date;
    });

    if (sortConfig.enabled) {
      const sortedValues = orderBy(dateValues, [], sortConfig.desc ? 'desc' : 'asc');
      filter.localStorage.filterValues = sortedValues.map((obj) => momentToStr(obj, format.date.inputFormat, format.locale));
    } else {
      //  console.log("Updating sorted Values",sortedValues, filter);
      filter.localStorage.filterValues = dateValues.map((obj) => momentToStr(obj, format.date.inputFormat, format.locale));
    }
    //const sortedValues = orderBy(dateValues, [], sort);
    //filter.localStorage.filterValues = sortedValues.map((obj) => momentToStr(obj, format.date.inputFormat, format.locale));
  }

  if (recalc) {
    //  check our options for recalc
    if (filter.options.saveState === 'allSelected') {
      filter.selectedValues = [];
    }
    //  do nothing if it is user selected
  }

  //  check that our selected values are still possible
  if (filter.selectedValues.length > 0) {
    const possibleSelectedValues = [];
    for (let i = 0; i < filter.selectedValues.length; i++) {
      if (filter.localStorage.filterValues.includes(filter.selectedValues[i])) {
        possibleSelectedValues.push(filter.selectedValues[i]);
      }
    }

    filter.selectedValues = possibleSelectedValues.filter((value) => value !== undefined && value !== null);
    if (filter.selectedValues.length > 0) {
      if (options.multiFilterValues && format.formatType === 'string') {
        data = data.filter(
          (obj) =>
            obj[fieldName] && parseMultiFilterValue(obj[fieldName], options.multiFilterDelimiter ?? '|').some((value) => filter.selectedValues.includes(value)),
        );
      } else {
        data = data.filter((obj) => filter.selectedValues.includes(obj[fieldName]));
      }
    }
  }

  return { content: content, data: data };
};

const applyValueSelectorInVisualFilter = (content, data: DataRow[], filter, recalc) => {
  const { fieldName, options } = filter;
  //const { sort } = options; // is not editable at the moment was asc, desc
  const sortConfig = {
    enabled: content.typeSpecific?.style?.inVisualFilter?.dropdown?.items?.ordering?.enabled,
    desc: content.typeSpecific?.style?.inVisualFilter?.dropdown?.items?.ordering?.desc,
  };

  //console.log("[ApplyValueSelectorInVisualFilter] ", content.typeSpecific?.style)
  if (!filter.localStorage) filter.localStorage = { filterValues: [] };
  //  if localStorage defined and has a value -> use this
  const { format } = content.typeSpecific.fields[fieldName];
  //  console.log("Updating sorted Values",format, filter);
  if (format.formatType === 'string') {
    let values: any[] = [];
    if (options.multiFilterValues) {
      values = parseMultiFilterData(data, fieldName, options.multiFilterDelimiter ?? '|');
    } else {
      values = data.map((obj) => obj[fieldName]);
    }

    const uniqueValues = unique(values);
    if (sortConfig.enabled) {
      const sortedValues = orderBy(uniqueValues, [], sortConfig.desc ? 'desc' : 'asc');
      filter.localStorage.filterValues = sortedValues;
    } else {
      filter.localStorage.filterValues = uniqueValues;
    }
    //  console.log("Updating sorted Values",sortedValues, filter);
  }
  //if we only have one value filter is not shown and we do not need to select
  //anything
  if (format.formatType === 'date') {
    const uniqueValues = unique(data.map((obj) => obj[fieldName]));
    const dateValues = uniqueValues.map((obj) => {
      const date = objToMoment(obj, format.date.inputFormat, format.locale);
      return date;
    });

    if (sortConfig.enabled) {
      const sortedValues = orderBy(dateValues, [], sortConfig.desc ? 'desc' : 'asc');
      filter.localStorage.filterValues = sortedValues.map((obj) => momentToStr(obj, format.date.inputFormat, format.locale));
    } else {
      //  console.log("Updating sorted Values",sortedValues, filter);
      filter.localStorage.filterValues = dateValues.map((obj) => momentToStr(obj, format.date.inputFormat, format.locale));
    }
  }

  if (!Array.isArray(filter.localStorage.filterValues) || filter.localStorage.filterValues.length < 2) {
    filter.selectedValue = undefined;
    return { data, content };
  }

  //  lets see if we need to recalc
  if (recalc) {
    if (filter.options.saveState === 'last') {
      filter.selectedValue = filter.localStorage.filterValues[filter.localStorage.filterValues.length - 1];
    }

    if (filter.options.saveState === 'first') {
      filter.selectedValue = filter.localStorage.filterValues[0];
    }
    //  do nothing if it is user selected
    //console.log("[recalc] Selected Value : ", filter.selectedValue, " localstorage values after sort: ", filter.localStorage.filterValues, " selecting: ", filter.options.saveState)
  }

  //  lets check if the selectedValue is still possible
  if (!filter.selectedValue || !filter.localStorage.filterValues.includes(filter.selectedValue)) {
    if (filter.options.saveState === 'last') {
      filter.selectedValue = filter.localStorage.filterValues[filter.localStorage.filterValues.length - 1];
    }

    if (filter.options.saveState === 'first') {
      filter.selectedValue = filter.localStorage.filterValues[0];
    }
    //  on user defined we still need to set something if its not set
    if (filter.options.saveState === 'userSelected') {
      filter.selectedValue = filter.localStorage.filterValues[filter.localStorage.filterValues.length - 1];
    }
  }

  //console.log("[DataPipeline] - Selected Value :", filter.selectedValue, " localstorage values after sort: ", filter.localStorage.filterValues, " selecting: ", filter.options.saveState);
  //  if(filter.selectedValue) {
  if (options.multiFilterValues && format.formatType === 'string') {
    data = data.filter(
      (obj) => obj[fieldName] && parseMultiFilterValue(obj[fieldName], options.multiFilterDelimiter ?? '|').some((value) => filter.selectedValue === value),
    );
  } else {
    data = data.filter((obj) => obj[fieldName] === filter.selectedValue);
  }
  //  }
  return { data, content };
};

/*
  Filters defined in the contentItem Type Specific fields parts
  -> selected values
 */
const applyEditorFilter = (content, data: DataRow[]) => {
  for (const field of Object.values<any>(content.typeSpecific.fields)) {
    if (field.dataType === 'number') continue;

    // for some reason null/undefined found it's way in here..
    field.selectedValues = field.selectedValues.filter((value) => value !== undefined && value !== null);
    if (field.selectedValues.length === 0) continue;

    // if the current dataset has not any of the selected values, skip this field
    const uniqueFieldValues = unique(data.map((row) => row[field.fieldName]));
    if (!field.selectedValues.some((value) => uniqueFieldValues.includes(value))) {
      // if uniqueness is needed, update selected values
      if (field.isNeededForUniqueness && uniqueFieldValues.length > 0) {
        field.selectedValues = [uniqueFieldValues[uniqueFieldValues.length - 1]];
      } else {
        continue;
      }
    }

    // const filterSet = new Set<string>(field.selectedValues);
    // data = data.filter((obj) => filterSet.has(obj[field.fieldName]));
    data = data.filter((obj) => field.selectedValues.includes(obj[field.fieldName]));
  }

  return { data, content };
};

//  TODO if we have better datastructure we dont need this
const addMetaInfo = (content, data: DataRow[]) => {
  const timeField = getTimeFieldName(content?.typeSpecific?.fields);
  let inputFormat, locale;
  if (timeField) {
    const { format } = content.typeSpecific.fields[timeField];
    locale = format.locale;
    inputFormat = format.date.inputFormat;
  }

  const timeMap = new Map<string, any>();

  for (let idx = 0; idx < data.length; idx++) {
    const obj = data[idx];

    // ~ works since mdc filters everything but 0-9A-z
    // ~ also does not break the fieldNameIndex since it's > z
    obj['~meta'] = { rowId: idx };

    if (timeField) {
      if (typeof obj[timeField] === 'number') {
        obj[timeField] = String(obj[timeField]);
      }

      if (timeMap.has(obj[timeField])) {
        obj['~meta'].moment = timeMap.get(obj[timeField]);
      } else {
        obj['~meta'].moment = objToMoment(obj[timeField], inputFormat, locale);
        timeMap.set(obj[timeField], obj['~meta'].moment);
      }
    }
  }

  return { data, content };
};

/**
 * clears Null Values - choro flowchor and markers shouldnt call this
 */
const clearNulls = (content, data: DataRow[]) => {
  const { type } = content;
  const labelField = getRightLabelFieldName(content.type, content?.typeSpecific?.dimensions);
  const legendField = getRightLegendFieldName(content.type, content?.typeSpecific?.dimensions);
  const valueField = getValueFieldName(content?.typeSpecific?.dimensions);
  // const isoField = getIsoField(content?.typeSpecific?.fields);

  if (valueField && type !== 'choropleth') {
    data = data.filter((obj) => obj[valueField] != null);
  }

  if (labelField && type !== 'choropleth') {
    data = data.filter((obj) => obj[labelField] != null);
  }

  if (legendField && type !== 'choropleth') {
    data = data.filter((obj) => obj[legendField] != null);
  }

  if (TableTypes.includes(type)) {
    const fields = Object.keys(content.typeSpecific.fields);
    data = data.filter((obj) => !Object.entries(obj).every(([key, val]) => (fields.includes(key) ? val === null : true)));
  }
  // if (isoField && type === 'choropleth') {
  //   data = data.filter((obj) => obj[isoField.fieldName] != null);
  // }

  // console.log('CLEAR DATA', isoField, cloneObject(data));

  return { data: data, content: content };
};

const getValueRange = (content, data: DataRow[]) => {
  const valueField = getValueFieldName(content?.typeSpecific?.dimensions);
  //  special case for choros cause those damn suckers can have fields where iso is not the right one
  if (valueField) {
    if (content.type === 'choropleth') {
      const isoFieldname = getIsoFieldName(content?.typeSpecific?.fields);
      const extendData = data.filter((el) => el[isoFieldname] != null);
      const stupidTypedStringRange: string[] = extent(extendData.map((obj) => obj[valueField]));
      const minRange = Number.parseFloat(`${stupidTypedStringRange[0]}`);
      const maxRange = Number.parseFloat(`${stupidTypedStringRange[1]}`);

      return [minRange, maxRange];
    }

    if (content.typeSpecific.chart.waterfall?.enabled) {
      const waterfallSums = content.typeSpecific.chart.waterfall.sumBars || [];
      const { labelField, aggregationField } = getOldFields(content.type, content?.typeSpecific?.dimensions);

      let numbers: number[] = [];
      if (GroupedOrStackedTypes.includes(content.type)) {
        const waterfallAcc: any = {};
        for (const row of data) {
          if (!waterfallAcc[row[aggregationField]]) waterfallAcc[row[aggregationField]] = { positive: 0, negative: 0 };
          if (row[valueField] > 0) waterfallAcc[row[aggregationField]].positive += waterfallSums.includes(row[aggregationField]) ? 0 : row[valueField];
          else waterfallAcc[row[aggregationField]].negative += waterfallSums.includes(row[aggregationField]) ? 0 : row[valueField];
        }

        let min = 0;
        let max = 0;
        let base = 0;

        for (const item of Object.entries(waterfallAcc)) {
          const values = item as any;
          max = Math.max(max, base + values[1].positive);
          min = Math.min(min, base + values[1].negative);
          base = base + values[1].positive + values[1].negative;
        }

        return [min, max];
      }

      numbers = data.map((row) => (waterfallSums.includes(row[labelField]) ? 0 : row[valueField]));
      const result = numbers.reduce((acc: number[], cur: number, idx: number) => (idx > 0 ? acc.concat(cur + acc[idx - 1]) : [cur]), []);

      let min = Math.min(...result);
      let max = Math.max(...result);
      if (min > 0 && min < 5) min = 0; // Force negative area, so labels don't overlap axis

      return [min, max];
    }

    let stupidTypedStringRange: string[] = extent(data.map((obj) => obj[valueField]));
    const minRange = Number.parseFloat(`${stupidTypedStringRange[0]}`);
    const maxRange = Number.parseFloat(`${stupidTypedStringRange[1]}`);

    return [minRange, maxRange];
  }

  // For the Table2 Heatmap, we need a range
  if (TableTypes.includes(content?.type) && content?.typeSpecific?.fields && content?.typeSpecific?.table2) {
    const table2 = content?.typeSpecific?.table2;
    const fieldsArray = Object.values(content?.typeSpecific?.fields) as Field[];

    // Numeric columns
    const min: number[] = [];
    const max: number[] = [];
    const numericFields = fieldsArray.filter((field: Field) => field.fieldType === 'valueField');

    for (const field of numericFields) {
      const extendData = data.filter((row) => row[field.fieldName] != null);

      let stupidTypedStringRange: string[] = extent(extendData.map((obj) => obj[field.fieldName]));
      const minRange = Number.parseFloat(`${stupidTypedStringRange[0]}`);
      const maxRange = Number.parseFloat(`${stupidTypedStringRange[1]}`);

      if (!Number.isNaN(minRange)) min.push(minRange);
      if (!Number.isNaN(maxRange)) max.push(maxRange);
    }

    // Text Mixed columns
    const mixedFieldNames = table2.columns.items.filter((col) => col.mixed).map((col) => col.fieldName);
    const textFields = fieldsArray.filter((field: Field) => field.fieldType === 'miscField' && mixedFieldNames.includes(field.fieldName));

    for (const field of textFields) {
      const extendData = data
        .map((row) => {
          const { value, prefix, suffix } = stringToNumber(row[field.fieldName], field.format.locale);
          const error = Number.isNaN(value - Number.parseFloat(`${value}`));
          return { value, prefix, suffix, error };
        })
        .filter((detection) => !detection.error);

      let stupidTypedStringRange = extent(extendData.map((obj) => obj.value));
      const minRange = Number.parseFloat(`${stupidTypedStringRange[0]}`);
      const maxRange = Number.parseFloat(`${stupidTypedStringRange[1]}`);

      if (!Number.isNaN(minRange)) min.push(minRange);
      if (!Number.isNaN(maxRange)) max.push(maxRange);
    }

    return [Math.min(...min), Math.max(...max)];
  }

  return [0, 0];
};

export const updateOptimalRoundingFormat = (content, data: DataRow[]) => {
  const decimalMap = {};
  const valueFieldName = getValueFieldName(content.typeSpecific.dimensions);
  if (!valueFieldName) return;

  updateAllQuillObjects(content, (quillObj) => {
    for (const op of quillObj.ops) {
      if (op.insert?.hasOwnProperty('inlineValue')) {
        const { fieldName, format } = op.insert.inlineValue;

        if (fieldName === valueFieldName && format) {
          if (format.number.optimalRounding) {
            const fieldData = data.map((row) => row[fieldName]).filter((num) => num !== undefined && num !== null);
            format.number.decimalPlaces = decimalMap[fieldName] ?? getOptimalDecimalPlaces(fieldData);
            format.number.numberFormat = getNumberFormat(format);
            decimalMap[fieldName] = format.decimalPlaces;
          }
        }
      }
    }

    return quillObj;
  });

  if (content.type === 'choropleth') {
    const { format } = content.typeSpecific.map.legend.values;

    if (format.number.optimalRounding) {
      const fieldData = data.map((row) => row[valueFieldName]).filter((num) => num !== undefined && num !== null);
      format.number.decimalPlaces = getOptimalDecimalPlaces(fieldData);
      format.number.numberFormat = getNumberFormat(format);
    }
  }
};

const sortByContent = (content, data: DataRow[]) => {
  const { type, typeSpecific } = content;
  if (!typeSpecific.chart) return { data: data, content: content };
  if (!ChartTypes.includes(type)) {
    return { data: data, content: content };
  }

  const { sorting } = content.typeSpecific.chart;
  if (sorting) {
    const fieldSortFn = (a, b) => {
      let ret = 0;

      for (const field of sorting.fields) {
        const { fieldName, direction } = field;
        if (!typeSpecific.fields[fieldName]) continue;

        const { dataType } = typeSpecific.fields[fieldName];
        const modifier = direction === 'asc' ? 1 : -1;

        if (dataType === 'number') {
          ret = a[fieldName] - b[fieldName];
        } else if (dataType === 'string') {
          if (a[fieldName] > b[fieldName]) ret = 1;
          if (a[fieldName] < b[fieldName]) ret = -1;
        } else if (dataType === 'date') {
          ret = a['~meta'].moment - b['~meta'].moment;
        }

        if (ret !== 0) {
          ret = ret * modifier;
          break;
        }
      }

      return ret;
    };

    if (sorting.enabled) {
      data.sort(fieldSortFn);
    }

    // TODO: this needs some better fix, at the moment there is old content being sorted wrong
    const needsTimeSorting = LineChartTypes.includes(type);
    if (needsTimeSorting) {
      const { fieldName } = typeSpecific.dimensions.find((obj) => obj.dimName === 'xAxis');
      const { dataType } = typeSpecific.fields[fieldName];

      if (dataType === 'date') {
        data.sort((a, b) => a['~meta'].moment - b['~meta'].moment);
      }
    }
  }

  return { data: data, content: content };
};

/**
 * Applys Smart Functions
 */
const applySmartFunctions = (content, data: DataRow[]) => {
  if (!content.typeSpecific || !content.typeSpecific.smartFunctions || content.typeSpecific.smartFunctions.length === 0) {
    return { data: data, content: content };
  }
  for (const smartFunction of content.typeSpecific.smartFunctions) {
    //  implementing smart Filter parts
    switch (smartFunction.name) {
      case 'timeChange': {
        //  console.log('CALLING SMART FUNCTIONS', content.typeSpecific, smartFunction);
        const ret = applyTimeChangeSmartFunction(data, content, smartFunction);
        data = ret.data;
        content = ret.content;
        break;
      }
      case 'stepFilter': {
        const ret = applySelectStepsSmartFunction(data, content, smartFunction);
        data = ret.data;
        content = ret.content;
        //  todo what about content?
        break;
      }
      case 'singleFieldCalculate': {
        const ret = applySingleFieldCalculate(content, data, smartFunction);
        data = ret.data;
        content = ret.content;
        break;
      }
      default:
        console.error('smartFunction Error no implementation for: ', smartFunction, data, content);
    }
  }
  return { data: data, content: content };
};
/**
 *  Implementation for Each Smart Function
 *
 */
const applySingleFieldCalculate = (content, data: DataRow[], smartFunction) => {
  if (!smartFunction.parameters.error) {
    //  lets calculate
    const fieldName = smartFunction.parameters.fieldName;
    //  console.log("[DataPipeline] - input data first value",data[0][fieldName]);
    const functionValue = Number.parseFloat(smartFunction.parameters.functionValue);
    if (!Number.isNaN(functionValue)) {
      //  console.log("[DataPipeline] - applying singleFieldCalculate",fieldName, " value: ",functionValue);
      data = data.map((row) => {
        const hasValue = !Number.isNaN(Number.parseFloat(row[fieldName]));
        if (hasValue) {
          switch (smartFunction.parameters.functionToApply) {
            case 'add':
              row[fieldName] = row[fieldName] + functionValue;
              break;
            case 'subtract':
              row[fieldName] = row[fieldName] - functionValue;
              break;
            case 'multiply':
              row[fieldName] = row[fieldName] * functionValue;
              break;
            case 'divide':
              row[fieldName] = row[fieldName] / functionValue;
              break;
            default:
              // console.log("Unrecognised smartFunction: ",smartFunction.parameters.functionToApply);
              break;
          }
        }
        return row;
      });
    }
  } else {
    //  console.log("[DataPipeline] - smartFunction with Error: ",smartFunction);
  }
  return { data: data, content: content };
};

/**
 * Applys Time ChangeSmartFunction
 * @param  data complete raw data object
 * @param  content contentItem
 * @param  smartFunction Object of the smart function
 * am besten do not touch!
 */
const applyTimeChangeSmartFunction = (data: DataRow[], content, smartFunction) => {
  const timeField = getTimeFieldName(content?.typeSpecific?.fields);
  const { amountPeriodBack, outputValue, outputFieldName, outputFormat, refValueField, outputFieldTitle } = smartFunction.parameters;

  if (timeField) {
    //  filter non valid times -> which shouldnt exist anyway
    data = data.filter((el) => el[timeField] != null);
    let timeFieldTypeSpec = null;
    //  nothing is done yet we are operating on the rawData
    //  get UniqueDataSet - includes in visualFilters now
    const compareFieldNames: string[] = [];
    for (const fieldName of Object.keys(content.typeSpecific.fields)) {
      const currentField = content.typeSpecific.fields[fieldName];
      if (fieldName === timeField) {
        timeFieldTypeSpec = currentField;
      }
      //  needed for uniqueness part
      if (fieldName !== timeField && currentField.selectedValues.length > 0 && currentField.isNeededForUniqueness) {
        compareFieldNames.push(currentField.fieldName);
      }
    }
    const locale = timeFieldTypeSpec.format.locale;
    const inputFormat = timeFieldTypeSpec.format.date.inputFormat;
    //  console.log('creating new column: ', outputFieldName, 'timeField: ', timeFieldTypeSpec);
    //  create new column for time changes add it to typespecific
    //  compareFields after is needed for uniqueness
    for (const dimension of content.typeSpecific.dimensions) {
      const field = content.typeSpecific.fields[dimension.fieldName];
      if (dimension.fieldName !== timeField && dimension.usedForUniqueness && field.dataType !== 'number') {
        if (content.typeSpecific.fields[dimension.fieldName].isoIsoField) {
          if (!compareFieldNames.includes(dimension.fieldName)) {
            compareFieldNames.push(dimension.fieldName);
          }
          if (!compareFieldNames.includes(content.typeSpecific.fields[dimension.fieldName].isoIsoField)) {
            compareFieldNames.push(content.typeSpecific.fields[dimension.fieldName].isoIsoField);
          }
        } else {
          if (!compareFieldNames.includes(dimension.fieldName)) {
            compareFieldNames.push(dimension.fieldName);
          }
        }
      }
    }
    for (const inVisualFilter of content.typeSpecific.inVisualFilter) {
      if (inVisualFilter.type === 'valueSelector' && inVisualFilter.fieldName !== timeField) {
        //  console.log('CALLING SMART FUNCTIONS', content.typeSpecific, smartFunction);
        if (!compareFieldNames.includes(inVisualFilter.fieldName)) {
          compareFieldNames.push(inVisualFilter.fieldName);
        }
      }
    }
    //extra check for table since dimensions are not set here
    if (content && TableTypes.includes(content.type)) {
      const uniqueFieldNamesResp = findBestUniquenessFieldNames(content, data);
      if (uniqueFieldNamesResp.unique) {
        for (const fieldName of uniqueFieldNamesResp.fieldNames) {
          if (!compareFieldNames.includes(fieldName) && fieldName !== timeField) {
            compareFieldNames.push(fieldName);
          }
        }
      }
    }
    //  get unqiue time values to calculate what 1 step is
    let uniqueTimeValues = unique(data.map((element) => element[timeField]).filter((el) => el != null));
    if (uniqueTimeValues.length > 1) {
      uniqueTimeValues = orderBy(
        uniqueTimeValues.map((obj) => objToMoment(obj, inputFormat, locale)),
        [],
        'asc',
      );
      //  make this back to string
      uniqueTimeValues = uniqueTimeValues.map((el) => {
        return momentToStr(el, inputFormat, locale);
      });
      //  console.log("unique Time Values: ",uniqueTimeValues)
      //  hash map has fast access
      const tempSearchMap = {};
      for (const row of data) {
        let key = '';
        for (const compareField of compareFieldNames) {
          key += row[compareField];
        }
        key += row[timeField];
        tempSearchMap[key] = row;
      }
      //  console.log("searchMap: ",tempSearchMap);
      for (const row of data) {
        const currentVal = row[refValueField.fieldName];
        const searchTimeIndex = uniqueTimeValues.indexOf(row[timeField]) - amountPeriodBack;
        //  console.log("row: ",row,searchTimeIndex);
        if (searchTimeIndex >= 0) {
          const searchTimeVal = uniqueTimeValues[searchTimeIndex];
          let key = '';
          for (const compareField of compareFieldNames) {
            key += row[compareField];
          }
          key += searchTimeVal;
          const refRow = tempSearchMap[key];
          if (refRow) {
            if (outputValue === 'percent') {
              //  no more na or infinity parts
              if (refRow[refValueField.fieldName] === 0 || currentVal === 0 || refRow[refValueField.fieldName] === null || currentVal === null) {
                row[outputFieldName] = null;
              } else {
                row[outputFieldName] = (currentVal / refRow[refValueField.fieldName] - 1) * 100;
              }
            } else {
              //  what if one of the values doesnt exist at all?
              if (refRow[refValueField.fieldName] === null || currentVal === null) {
                row[outputFieldName] = null;
              } else {
                row[outputFieldName] = currentVal - refRow[refValueField.fieldName];
              }
            }
          } else {
            row[outputFieldName] = null;
          }
        } else {
          //  out of scope
          row[outputFieldName] = null;
        }
      }
      //  typeSpecific changes
      //  set new FieldValues
      //  console.log('Fields before setting new field: ', content.typeSpecific.fields);
      const newValueFormat = cloneObject(outputFormat);
      //  check if content already has our outputFieldName
      if (content.typeSpecific.fields[outputFieldName]) {
        // console.log('Create New Value Field: ');
        content = createNewValueFieldFromExisting(content, refValueField.fieldName, outputFieldName, outputFieldTitle, newValueFormat);
      } else {
        // console.log('Set New Value Field: ');
        content = setNewValueField(content, refValueField.fieldName, outputFieldName, outputFieldTitle, newValueFormat);
      }
      //  console.log(data);
    }
  }
  return { data: data, content: content };
};

const applySelectStepsSmartFunction = (data: DataRow[], content, smartFunction) => {
  //  works without change for axis parts
  //  console.log("INPUT DATA LENGTH: ",data.length);
  //  console.log("SmartFilter: ",smartFilter);
  const { field } = smartFunction.parameters;
  const stepSize = Number.parseInt(smartFunction.parameters.stepSize);
  let uniqueTimeValues = unique(data.map((element) => element[field.fieldName]));
  const { inputFormat } = field.format.date;
  uniqueTimeValues = uniqueTimeValues.map((el) => {
    return {
      label: el,
      moment: objToMoment(el, inputFormat, field.format.locale),
    };
  });
  //  sort descending
  uniqueTimeValues.sort((left: any, right: any) => right.moment - left.moment);
  //  console.log("Unique Time Values sorted Descending: ",uniqueTimeValues);
  //  sort
  const selectedTimes: string[] = [];
  for (let i = 0; i < uniqueTimeValues.length; i = i + stepSize) {
    //  console.log("getting: ",i)
    selectedTimes.push(uniqueTimeValues[i].label);
  }
  //  select this fun in the data
  data = data.filter((el) => selectedTimes.includes(el[field.fieldName]));
  //  content.typeSpecific.fields[field.fieldName].selectedValues = cloneObject(selectedTimes);
  return { data: data, content: content };
};

/**
 *
 * Smart Filters
 * in the datapipeline we already have applied
 * - metaInfos
 * - smart functions
 * - editor filters
 *
 * For ex
 *
 */
const applySmartFilter = (data: DataRow[], content) => {
  if (!content.typeSpecific.smartFilters || content.typeSpecific.smartFilters.length === 0) {
    return data;
  }
  for (const smartFilter of content.typeSpecific.smartFilters) {
    //  implementing smart Filter parts
    switch (smartFilter.name) {
      case 'enableTop': {
        //  for most charts top means the axis where a value field is used
        data = applyTopBottomFilter(data, content, smartFilter, 'desc');
        break;
      }
      case 'enableBottom': {
        data = applyTopBottomFilter(data, content, smartFilter, 'asc');
        break;
      }
      case 'geographicalPreference': {
        //  done for axis
        data = applyGeoFilter(data, content, smartFilter);
        break;
      }
      case 'selectTimeLatest': {
        data = applyselectTimeLatestFilter(data, content, smartFilter);
        break;
      }

      default:
        console.error('smartFilter Error no implementation for: ', smartFilter, data, content);
    }
  }
  //  console.log("Smart FILTER BEFORE RETURN: ",items);
  return data;
};

/**
 *  Implementation for Each Smart Filter
 *  TODO think about saving relevant timefieldInfo
 *  into the filter to enable multiple timefields
 */
const applyselectTimeLatestFilter = (data: DataRow[], content, smartFilter) => {
  const timeField = getTimeFieldName(content?.typeSpecific?.fields);
  if (timeField) {
    const { format } = content.typeSpecific.fields[timeField];
    const locale = format.locale;
    const inputFormat = format.date.inputFormat;
    const latest = Number.parseInt(smartFilter.parameters.latest);
    //  get unique time Values and Sort Them
    let uniqueTimeValues = unique(data.map((element) => element[timeField]).filter((el) => el != null));
    if (uniqueTimeValues.length > 1) {
      uniqueTimeValues = orderBy(
        uniqueTimeValues.map((obj) => {
          return objToMoment(obj, inputFormat, locale);
        }),
        [],
        'desc',
      );
      //  make this back to string
      uniqueTimeValues = uniqueTimeValues.map((el) => momentToStr(el, inputFormat, locale));
      // console.log('APPLYING LATEST FILTER: ', uniqueTimeValues);
      //  select from data only the amount of latest
      uniqueTimeValues = uniqueTimeValues.slice(0, latest);
      // console.log('APPLYING LATEST FILTER: AFTER SLICE ', uniqueTimeValues);
      data = data.filter((el) => uniqueTimeValues.includes(el[timeField]));
    }
    // console.log('after latest filter: ', data, uniqueTimeValues);
  }

  return data;
};

/**
 * filters for geodata
 * TODO save isoFieldName into the filter to enable
 * multiple isoField usage
 */
const applyGeoFilter = (data: DataRow[], content, smartFilter) => {
  const isoField = getIsoFieldName(content?.typeSpecific?.fields);
  //  go through fields in typespec fields and check for iso
  if (isoField) {
    let additionItems: DataRow[] = [];
    if (MapTypes.includes(content.type)) {
      additionItems = data.filter((obj) => obj[isoField] === null);
    }
    data = data.filter((obj) => smartFilter.parameters.isoCodes.includes(obj[isoField]));
    data.push(...additionItems);
  }
  return data;
};

/**
 * applies smart Filters on axis object
 * General Idea:
 *  top is always dependant on the dimensions object
 *  and uniquefilters
 *  - for 2 dimensional charttypes:
 *      - y dimension always has values in it
 *      - x dimension always has the categories / labels we want to filter away
 *
 *    - needs to be calculated for each individual config of an invisual filter
 *
 * - for 3 dimensional charttypes
 *      -
 *
 * @param  data                [description]
 * @param  content             [description]
 * @param  smartFilter         [description]
 * @return                     [description]
 */
const applyTopBottomFilter = (data: DataRow[], content, smartFilter, direction: 'asc' | 'desc' = 'desc') => {
  if (content && TableTypes.includes(content.type)) {
    //TOP BOTTOM CANNOT BE USED
    return data;
  }
  //  console.log('Applying Top/Bottom Filter', data, content, smartFilter);
  //  if we apply each In visual filter once
  //  we can calculate for each combination of in visual filters
  //  the top part -> very expensive

  //  if it is static it calculates the tops one time
  //  and then only selects the top of
  const labelField = getLabelFieldName(content.type, content?.typeSpecific?.dimensions);
  const valueField = getValueFieldName(content?.typeSpecific?.dimensions);
  const isoField = getIsoFieldName(content?.typeSpecific?.fields);
  //  static or dynamic calculation?
  const amount = smartFilter.parameters.topValue || smartFilter.parameters.bottomValue;

  let additionItems = [];
  if (MapTypes.includes(content.type)) {
    additionItems = data.filter((obj) => obj[isoField] === null);
    data = data.filter((obj) => obj[isoField] != null);
  }
  //  lets take a different approach then before lets get the unique parts and sort for
  //  when do we have to separately calc tops-
  // - indivudual filters single select
  // - axis that are not x and y axis?
  const bucketFieldNames: string[] = [];
  for (const inVisualFilter of content.typeSpecific.inVisualFilter) {
    if (inVisualFilter.type === 'valueSelector') {
      if (!bucketFieldNames.includes(inVisualFilter.fieldName)) {
        bucketFieldNames.push(inVisualFilter.fieldName);
      }
    }
  }
  //  we have to calc for each bucket at least . but maybe there is more
  // for a linechart TOP2 dynamic is
  // for each invisualFilter valueSelector
  // for each xAxisValue -> the top 2 labels of Y Axis
  if (content.typeSpecific.dimensions.length > 2) {
    for (const dimension of content.typeSpecific.dimensions) {
      if (dimension.usedForUniqueness && dimension.dimName !== 'iso') {
        //  we have to make a type switch here since group and stacked
        //  have different axis then the rest.. buuh
        if (['groupedbarchart', 'stackedbarchart', 'bar-grouped-horizontal', 'bar-stacked-horizontal'].includes(content.type)) {
          //  in grouped and stacked we want per group Axis the things
          if (dimension.dimName === 'groupAxis') {
            if (!bucketFieldNames.includes(dimension.fieldName)) {
              bucketFieldNames.push(dimension.fieldName);
            }
          }
        } else {
          //  this are time charts and we want per year aka xAxis value the tops
          if (dimension.dimName === 'xAxis') {
            if (!bucketFieldNames.includes(dimension.fieldName)) {
              bucketFieldNames.push(dimension.fieldName);
            }
          }
        }
      }
    }
  }

  if (smartFilter.parameters.static?.enabled) {
    // static mode -> TODO for multiple inVisualValue Selectors it is
    // random and we just make it setable by the user
    const mode = smartFilter.parameters.static.mode;
    const sortMode = mode === 'min' ? 'asc' : 'desc';
    // for all buckets choose one -> highest sorted by type for each bucketField
    // -> [2018]['gamma'] ---> top
    // -->  get the  labels
    if (bucketFieldNames.length > 0) {
      //  console.log('[DataPipeline] - Top Static - ', content, bucketFieldNames, mode);
      const bucketSelector = {};
      //  for greatest or lowerst sorted depending on type calc bucket with one value fixed
      for (const fieldName of bucketFieldNames) {
        let uniqueValues = unique(data.map((el) => el[fieldName]));
        if (content.typeSpecific.fields[fieldName].dataType === 'date') {
          const { format } = content.typeSpecific.fields[fieldName];
          //  sort desc
          uniqueValues = orderBy(
            uniqueValues.map((obj) => objToMoment(obj, format.date.inputFormat, format.locale)),
            [],
            sortMode,
          );
          // console.log('DATE VALUE ORDER: ', uniqueValues);
          //  take first
          const lastVal = momentToStr(uniqueValues[0], format.date.inputFormat, format.locale);
          bucketSelector[fieldName] = lastVal;
        } else {
          uniqueValues = orderBy(uniqueValues, [], sortMode);
          // console.log('STRING VALUE ORDER: ', uniqueValues);
          const lastVal = uniqueValues[0];
          bucketSelector[fieldName] = lastVal;
        }
      }
      // console.log('BUCKET SELECTOR', bucketSelector);
      //  get the right bucket
      const selectedLabels = unique(
        orderBy(
          data.filter((el) => {
            for (const bucketField of bucketFieldNames) {
              if (el[bucketField] !== bucketSelector[bucketField]) return false;
            }
            return true;
          }),
          valueField,
          direction,
        )
          .slice(0, amount)
          .map((el) => el[labelField]),
      );
      //  get all the data
      data = data.filter((el) => selectedLabels.includes(el[labelField]));
    } else {
      //  console.log('[DataPipeline] - Top Static - without Buckets', valueField);
      //  well seems we just need top
      data = data.filter((el) => el[valueField] != null);
      data = orderBy(data, valueField, direction).slice(0, amount);
    }
  } else {
    /*
        DYNAMIC MODE
       */

    if (bucketFieldNames.length > 0) {
      //  console.log('[DataPipeline] - Top Dynamic - ', content, bucketFieldNames);
      const mapVals = {};
      data = data.filter((el) => el[valueField] != null);
      for (const row of data) {
        let hash = '';
        for (const fieldName of bucketFieldNames) {
          hash += row[fieldName];
        }
        if (mapVals[hash]) {
          mapVals[hash].push(row);
        } else {
          mapVals[hash] = [row];
        }
      }
      let tempData = [];
      for (const buckets of Object.keys(mapVals)) {
        tempData = tempData.concat(orderBy(mapVals[buckets], valueField, direction).slice(0, amount));
      }
      data = tempData;
    } else {
      //  console.log('[DataPipeline] - Top Dynamic - without Buckets', valueField);
      //  well seems we just need top
      data = data.filter((el) => el[valueField] != null);
      data = orderBy(data, valueField, direction).slice(0, amount);
    }
  }

  data.push(...additionItems);
  return data;
};

export const processDataPerType = (content, data: DataRow[]) => {
  if (EChartTypes.includes(content.type)) {
    if (content.type === EChartType.Sankey) {
      const { dimensions } = content.typeSpecific;
      const sourceDim = dimensions.find((dim) => dim.dimName === 'source');
      const targetDim = dimensions.find((dim) => dim.dimName === 'target');
      const validRows = validateNonCircularData(data, sourceDim.fieldName, targetDim.fieldName);
      return data.filter((row, idx: number) => validRows[idx]);
    }
  }
  return data;
};

export const patchMomentMMM = (content, data: DataRow[]) => {
  const months = [
    { old: 'Jan.', new: 'Jan' },
    { old: 'Feb.', new: 'Feb' },
    { old: 'März', new: 'Mär' },
    { old: 'Apr.', new: 'Apr' },
    // { old: 'Mai', new: 'Mai' },
    { old: 'Juni', new: 'Jun' },
    { old: 'Juli', new: 'Jul' },
    { old: 'Aug.', new: 'Aug' },
    { old: 'Sep.', new: 'Sep' },
    { old: 'Okt.', new: 'Okt' },
    { old: 'Nov.', new: 'Nov' },
    { old: 'Dez.', new: 'Dez' },
  ];

  const timeFieldName = getTimeFieldName(content.typeSpecific.fields);
  if (!timeFieldName) return data;

  const { locale: formatLocale } = content.typeSpecific.fields[timeFieldName].format;
  const { inputFormat, locale: dateLocale } = content.typeSpecific.fields[timeFieldName].format.date;
  const locale = dateLocale ?? formatLocale;

  if (!inputFormat.includes('MMM') || inputFormat.includes('MMMM') || !locale?.includes('de')) return data;

  for (const row of data) {
    for (const month of months) {
      row[timeFieldName] = row[timeFieldName].replace(month.old, month.new);
    }
  }

  return data;
};

export { addMetaInfo, applyEditorFilter, applyInVisualFilter, applySmartFilter, applySmartFunctions, clearNulls, getValueRange, sortByContent };
